// extracted by mini-css-extract-plugin
export default {"content":"Et_b971_cjp4bgQOmSpV","text":"qk2l_7qPcCNJbCzWgfWJ","restoreNotice":"wjj3PlF66dhNu3OCZYhl","buttonHolder":"nUY8UPxlDPL_CMbpj4Xj"};